import { render, staticRenderFns } from "./ConvertDetail.vue?vue&type=template&id=124b89f7&"
import script from "./ConvertDetail.vue?vue&type=script&lang=js&"
export * from "./ConvertDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConvertDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports